import type { FC } from "react";
import Link from "next/link";
import { useTypedSelector } from "@/stores";

export const menus = [] as {
  label: string;
  route: string;
}[];

if (process.env.NEXT_PUBLIC_IDO_PAGE_VISIBLE === "true") {
  menus.push({
    label: "IDO",
    route: "/ido/vesting",
  });
}

if (process.env.NEXT_PUBLIC_AIRDROP_PAGE_VISIBLE === "true") {
  menus.push({
    label: "Airdrop",
    route: "/network/airdrop",
  });
}

menus.push({
  label: "Mining",
  route: "/network/mining",
});

const hasAnnouncement = !!process.env.NEXT_PUBLIC_ANNOUNCEMENT;

const NetworkMenu: FC = () => {
  const hideAnnouncement = useTypedSelector((state) => {
    return state.app.hideAnnouncement;
  });

  const showAnnouncement = hasAnnouncement && !hideAnnouncement;

  return (
    <div
      className={`z-30 h-[60px] sticky ${
        showAnnouncement ? "top-[86px]" : "top-[56px]"
      } left-0 backdrop-blur bg-white/60 text-base layout-content px-5 md:px-[84px] flex items-center gap-11`}
    >
      {menus.map((menu, index) => {
        return (
          <Link key={index} href={menu.route}>
            <div className="text-sm font-semibold text-primary action">
              {menu.label}
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default NetworkMenu;
